import { SHOW_BRAND_INACTIVE_ALERT, SHOW_SHOPIFY_ADMIN_LINK, SHOW_SHOPIFY_CONNECTION_ALERT } from '../config/embedFlags';

// What the portal shows around the selected brand's pages — the sidebar's
// "Shopify admin" link and the two top alerts (inactive brand, Shopify
// connection) — each behind its flag in src/config/embedFlags.js. The pages
// themselves never depend on these, so they keep working for an inactive or
// disconnected brand.
export function brandChrome(brand, { embedded = false } = {}) {
  return {
    shopifyAdminLink: !!brand && !embedded && SHOW_SHOPIFY_ADMIN_LINK,
    // Outfino's suspension: always shown (no flag) while the session says so;
    // it replaces the inactive alert (the brand cannot act on that one then).
    suspendedAlert: !!brand && brand.adminSuspended === true,
    inactiveAlert: !!brand && brand.adminSuspended !== true && SHOW_BRAND_INACTIVE_ALERT,
    connectionAlert: !!brand && SHOW_SHOPIFY_CONNECTION_ALERT,
  };
}
